export const controllPalletTranslationHE = {
  controllPallet: {
    "controllPallet_title": "רשימת תעודות משטח",
    "controllPallet_newPallet": "משטח חדש",
    "controllPallet_printSuccess": "הדפסת משטח בוצעה בהצלחה",
    "controllPallet_printError": "שגיאה הדפסת משטח",
    "controllPallet_deleteSuccess": "משטח נמחק בהצלחה",
    "controllPallet_deleteError": "משטח לא נמחק",
    
    // From ControlPalletsTitle.jsx
    "controllPallet_update": "עדכון",
    "controllPallet_delete": "מחק",
    
    // From AddPalletDetailes.jsx
    "controllPallet_newPalletTitle": "משטח חדש",
    "controllPallet_palletWithId": "משטח: {{id}}",
    "controllPallet_customerUpdated": "לקוח עודכן בהצלחה",
    "controllPallet_customerNotUpdated": "לקוח לא עודכן",
    "controllPallet_itemDeleted": "פריט נמחק בהצלחה",
    "controllPallet_chooseCustomer": "בחור לקוח",
    "controllPallet_finish": "סיים",
    "controllPallet_newProduct": "הוסף פריט",
    "controllPallet_updateItem": "עדכון פריט",
    "controllPallet_externalPalletNumber": "מספר משטח חיצוני",
    "controllPallet_dividePallet": "פיצול משטח: {{palletNum}}",
    "controllPallet_dividePallet_notification_overflow": "כמות אריזות לפיצול גדולה מדי"
  }
}; 